import React from 'react';
import { Check } from 'lucide-react';

const PackageInclusions = ({ inclusions }) => {
  return (
    <div className="inclusions">
      <h4>Includes:</h4>
      <ul>
        {inclusions.map((item, i) => (
          <li key={i}>
            <Check className="check-icon" size={16} />
            <span dangerouslySetInnerHTML={{__html: item}} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PackageInclusions;